import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/winpresentation/SimplePresentationRunner";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {LonerNormalResultPresentation} from "../../presentationrunners/LonerNormalResultPresentation";
import {
    LonerPinTheWinResultPresentation
} from "../../presentationrunners/features/pinthewin/LonerPinTheWinResultPresentation";

export class LonerPinTheWinResultTrigger implements FlowStatePresentation{
    private _presentations:SimplePresentation[];
    private _flowStateController:FlowStateController;

    constructor() {
        this._presentations = [
            new LonerPinTheWinResultPresentation()
        ]
    }
    public start(flowStateController:FlowStateController):void {
        this._flowStateController = flowStateController;
        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?:Function) => flowStateController.setSkipCallback(callback));
    }
    public complete():void {
        this._flowStateController.finish();
    }
}